import { callServiceMachine } from '_core/util';
import Machines from '../Machines';
import { MemberTypes } from '../Types';

const machine = Machines.onGetMember.machine;

export const getMember = (): Promise<MemberTypes.IMemberServiceResponse> => {
  return callServiceMachine(machine);
};

export default { getMember };
